<script setup>
const props = defineProps({
  info: {
    required: true,
    type: Object,
  }
})

// 处理退款数量统计
const handleRefundQuantity = (list) => {
  console.log("list", list)
  if (list.length <= 0) return 0
  let count = 0
  list.map(i => {
    count += i.refundQuantity
  })
  return count
}
</script>

<template>
  <div class="refund_timeline">

    <!-- 买家 -->
    <div class="timeline_item">
      <div class="timeline_left">
        <div class="timeline_node buyer">
          买家
        </div>

        <div class="timeline-line"></div>
      </div>

      <div class="timeline-content">
        <div class="timeline_title">
          买家申请售后
        </div>

        <div class="timeline_info">
          <div>申请时间：{{info?.crTime ? info?.crTime : "—"}}</div>
          <div>退款数量：{{handleRefundQuantity(info?.refundItemList)}}</div>
          <div>退款金额：{{info?.isFullOrderRefund ? "整单退款" : "部分退款"}} {{info?.refundAmount ? `￥${info?.refundAmount}` : "—"}}</div>
          <div>申请原因：{{info?.refundReason ? info?.refundReason : "—"}}</div>
        </div>
      </div>
    </div>

    <!-- 商家 -->
    <div class="timeline_item">
      <div class="timeline_left">
        <div class="timeline_node seller">
          商家
        </div>
      </div>

      <div class="timeline-content">
        <div class="timeline_title">
          商家处理售后
        </div>

        <div class="timeline_info">
          <div v-if="info?.refundState === 'SUCCESS'">处理方式：同意申请</div>
          <div v-if="info?.refundState === 'REJECTED'">处理方式：拒绝申请</div>
          <div v-if="info?.rejectReason">拒绝说明：{{info?.rejectReason}}</div>
          <div v-if="info?.refundState === 'SUCCESS'">售后状态：售后完成</div>
          <div v-if="info?.refundState === 'REJECTED'">售后状态：售后结束</div>
          <div>退款时间：{{info?.refundTime}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.refund_timeline {

}

.timeline_item {
  display: flex;
}

.timeline_left {
  width: 64px;

  display: flex;
  flex-direction: column;
  align-items: center;

  flex-shrink: 0;
}

.timeline_node {
  width: 30px;
  height: 30px;

  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;

  &.buyer {
    color: #3E98F1;
    border: 1px solid #3E98F1;
    background: #F5FAFF;
    font-size: 11px;
  }

  &.seller {
    color: #4CAF50;
    border: 1px solid #4CAF50;
    background: #F1FFF2;
    font-size: 11px;
  }
}

.timeline-line {
  flex: 1;

  margin-top: 7px;
  margin-bottom: 7px;

  border-left: 1px dashed #dcdfe6;
}

.timeline-content {
  flex: 1;

  padding-bottom: 28px;
}

.timeline_title {
  font-family: OPPOSans;
  font-weight: 500;
  font-size: 15px;
  color: #272539;
  margin-top: 7px;
  margin-bottom: 14px;
  line-height: 15px;
}

.timeline_info {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 34px;

  font-size: 14px;
  line-height: 22px;
  font-family: OPPOSans;
  font-weight: 500;
  color: #6F717D;
}
</style>
